import type {VehicleMyWebPlatformAdvertisingAttribute} from './VehicleMyWebPlatformAdvertisingAttribute';

export type VehicleMyWebPlatformAdvertisingSettings = {
  platformCode: VehicleMyWebPlatformAdvertisingSettings.platformCode;
  enabled: boolean;
  attributes: Array<VehicleMyWebPlatformAdvertisingAttribute>;
  hasOverrides: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
};

export namespace VehicleMyWebPlatformAdvertisingSettings {
  export enum platformCode {
    MYWEB = 'myweb',
  }
}
